import { Link } from 'react-router-dom';
import { Button } from '../../components/Button';

export function NotFoundPage(): JSX.Element {
  return (
    <div className="md:h-full flex flex-col items-center justify-center text-center px-6 py-20">
      <h1 className="kc-serif text-6xl text-ink-4">404</h1>
      <p className="mt-3 text-ink-3">This page doesn&apos;t exist.</p>
      <Link to="/" className="mt-6">
        <Button variant="secondary">Back to dashboard</Button>
      </Link>
    </div>
  );
}
